<img src={{imgSrc}} style="width:{{logoWidth}}" alt={{vendor}} />